import { useRouter } from "next/router";

import { SUPPORTED_LOCALES } from "@/constants/language-and-locales";

/*
 * This function removes the leading locale from the path.
 * For example, if the path is "/en-NO/nettbutikk", it will return "/nettbutikk".
 * If the path does not start with a locale, it will return the path unchanged.
 */
const removeLeadingLocale = (path) => {
  const regex = /^\/[a-z]{2}-[A-Z]{2}\//;
  return path.replace(regex, "/");
};

const useUrl = () => {
  const baseUrl = process.env.NEXT_PUBLIC_URL;
  const router = useRouter();
  const { asPath, locale, defaultLocale } = router;
  const getLangPathPrefix = (_locale) =>
    _locale === defaultLocale ? "" : `/${_locale}`;

  // If path is empty, remove the slash
  const normalisedPath = asPath === "/" ? "" : removeLeadingLocale(asPath);

  const generateHreflangUrls = () => {
    return SUPPORTED_LOCALES.map((lang) => ({
      lang,
      url: `${baseUrl}${getLangPathPrefix(lang)}${normalisedPath}`,
    }));
  };

  const currentUrl = `${baseUrl}${getLangPathPrefix(locale)}${normalisedPath}`;

  return {
    currentUrl,
    baseUrl,
    generateHreflangUrls,
    langPathPrefix: getLangPathPrefix(locale),
  };
};

export default useUrl;
